module.exports = __webpack_public_path__ + "static/media/osm.5ef2f484.PNG";